import QuestionLabel from './QuestionLabel';
import SafeHtml from '../../SafeHtml.jsx';
import useCurrentBusiness from '~/lib/useCurrentBusiness.jsx';

const VideoEmbedQuestion = ({ label, value, setValue, settings }) => {
    const business = useCurrentBusiness();
    const isSpam = !!business?.is_spam;

    return (
        <label>
            <QuestionLabel label={label} settings={settings} />

            <div className="video-embed-question">
                <SafeHtml html={settings?.embed} stripLinks={isSpam} />
            </div>
        </label>
    );
};

export default VideoEmbedQuestion;
